<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">
      <el-col :span="4" v-if="theProjectId== 0" >
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col v-if="form.projectId">
        <el-button v-if="addProjectPropSpecialist"
          @click="$form('addProjectPropSpecialist')"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加项目支撑专家
        </el-button>
      </el-col>
    </el-row>
    <div>
        <myform
          :viewobj='{
            addProjectPropSpecialist:    [ "新增项目支撑专家", "el-icon-circle-plus" ],
            updateProjectPropSpecialist: [ "修改项目支撑专家", "el-icon-edit-outline"],
            $succeed$: getProjectPropSpecialistList
          }'
            @confirm='myform'
          @close='$form("addProjectPropSpecialist","reset")'
          >
          <hide slot='projectId' />
          <hide slot='yppsId' />

        </myform>
        <mytable
          :tableColums='tableColums_getProjectPropSpecialistList'
          api='getProjectPropSpecialistList'
          xupdateapi='updateOpportunityBusinessCheckImage'
          :height="H-165" >
        </mytable>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        theProjectId:0,
        value:'',
        form:{
          projectId:'',
          yasDate:'',
          yasCommand:'',
          yasTimeStart:'',
          yasTimeEnd:'',
          yasDes:'',
        },
        tableColums_getProjectPropSpecialistList:{
          $selection: false,

          // oiType: '限制字段key',

          yppsName: '项目支撑专家名称',


          $operation: [
            '操作', 200,
            this.updateProjectPropSpecialist && `@text: 编辑#success
             @click: $form("updateProjectPropSpecialist",$row)
            `,
            this.deleteProjectPropSpecialist && `@text: 删除#danger
             @click: _confirm('确定要删除该填写项约束吗?')
                     .trigger('deleteProjectPropSpecialist',{yppsId:$row.yppsId})
                     .trigger('getProjectPropSpecialistList',{projectId:form.projectId})
            `,
          ],
        }
      }
    },
    methods:{
      myform(submit, Myformdata){
        Myformdata.projectId = this.form.projectId;
           submit();
      },
      theProjectAllChange(e){
        if(e == ''){
          return  this.form.projectId = e;
        }
        this.form.projectId = e;
        this.getProjectPropSpecialistList({projectId:this.form.projectId})
      },
    },
    created(){
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }
      this.getProjectPropSpecialistList({projectId:this.form.projectId})
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bussiness/projectExpert.vue